export default "__VITE_ASSET__Ba0i7CZd__"